<template>
  <div>
    <div class="modal" id="myModal" tabindex="-1" v-if="modal == true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" >
        <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title" ><b>{{$t('modal1')}}</b></h4>
            <button type="button" class="btn-close" @click="modalClose" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="blog" id="blog">
          <div class="container aos-init aos-animate" data-aos="fade-up">
            <div class="row g-5">
              <div class="row gy-4 posts-list featured-services">
                <div class="d-flex flex-column" :key='i' v-for='(data, i) in popList'>
                  <div class="service-item">
                  <h2 class="title" v-html="data.commSubject"></h2>
                  <div class="meta-top">
                    <ul>
                      <li class="d-flex align-items-center"><i class="bi bi-person">&nbsp;<a>{{ data.commUserNm }}</a></i></li>
                      <li class="d-flex align-items-center"><i class="bi bi-clock">&nbsp;<a>{{ data.regDate }}</a></i></li>
                      <li class="d-flex align-items-center"><i class="bi bi-eye">&nbsp;<a>{{ data.commCount }}</a></i></li>
                      <li class="d-flex align-items-center" v-if='data.fileOrgName !== null && data.fileOrgName !== ""'><i class="bi bi-download"></i><a :href="this.$store.state.boardFilePath + data.filePath + data.fileName" :download="data.fileOrgName" id="download">{{ data.fileOrgName }}</a></li>
                    </ul>
                  </div>
                  <div class="content" v-html="data.commContent"></div>
                </div>
                </div>
             </div>
            </div>
          </div>
        </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="isCookie">{{$t('modal2')}}</button>
        </div>
        </div>
  </div>
</div>
</div>
    <main id="home">
      <MainPage></MainPage>
      <MainInfo></MainInfo>
    </main>
</template>

<script src="@/assets/js/views/HomeView.js"></script>
<style>
img {
  height: auto;
  max-width: 100%;
}
</style>

<style scoped>
#myModal{
    display: block;
    background: rgba(0,0,0,0.5);
    z-index: 9998;
}

#download:hover {
  color: #20c997;
}
</style>
